import { render, staticRenderFns } from "./EditTextButton.vue?vue&type=template&id=05088d08&scoped=true&"
import script from "./EditTextButton.vue?vue&type=script&lang=js&"
export * from "./EditTextButton.vue?vue&type=script&lang=js&"
import style0 from "./EditTextButton.vue?vue&type=style&index=0&id=05088d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05088d08",
  null
  
)

export default component.exports